let hero = {};

hero.video = function () {
  
  let currentIsDesktop = $('html.no-touchevents').length;
  let mobileVideo = $('.hero-mobile-vid')
  
  if (!currentIsDesktop) {
    let videoMobileClass = $('.hero-mb-vid');
    let videoDesktopClass = $('.hero-d-vid');

    if (videoMobileClass.hasClass('d-none') && videoMobileClass.hasClass('d-lg-block')) {
      videoMobileClass.removeClass('d-none d-lg-block').addClass('d-block d-lg-none');
    }

    if (videoDesktopClass) {
      videoDesktopClass.remove();
    }

  } else {
    mobileVideo.remove();
  }

}

hero.slider = function () {
	const $heroSlider = $('.js-hero-slider');

	if ($heroSlider.length === 0) {
		return;
	}

	$.each($heroSlider, function () {
		const $slider = $(this);
		const $slides = $slider.find('.hero-slider-slide');
		const isDesktop = window.innerWidth >= 768;
		const slideCount = $slides.length;
		const isInitialized = $slider.data('flickity') !== undefined;
		const $wrapper = $slider.closest('.hero-slider-wrapper');
		const $prevBtn = $wrapper.find('.prev-btn');
		const $nextBtn = $wrapper.find('.next-btn');
	
		if (isDesktop && slideCount <= 2) {
			$prevBtn.removeClass('d-lg-block');
			$nextBtn.removeClass('d-lg-block');

			if (isInitialized) {
				$slider.flickity('destroy');
			}
		} else {
			if (!isInitialized) {
				const flkty = $slider.flickity({
					cellAlign: 'left',
					wrapAround: true,
					dragThreshold: 10,
					prevNextButtons: false,
					pageDots: true,
				}).data('flickity');

				$prevBtn.addClass('d-lg-block');
				$nextBtn.addClass('d-lg-block');

				$prevBtn.on('click', function () {
					flkty.previous();
				});

				$nextBtn.on('click', function () {
					flkty.next();
				});
			}
		}
	});
}

hero.init = function () {
  hero.video();
  hero.slider();

  window.addEventListener('resize', window.stokpress.debounce(function () {
	hero.slider();
  }, 500));
}

hero.init();


// WEBPACK FOOTER //
// ./scripts/components/hero.js